import React, { useState } from "react"
import { useStripe, useElements, IbanElement } from "@stripe/react-stripe-js"
import StripeIbanForm from "./StripeIbanForm"
import ContactService from "../../../state/contact/services/ContactService"
type OwnProps = {
    contactId: string,
    saveAndChargeLater: boolean,
    onSetupIntentSubmit: (setupIntent) => void,
    testMode: boolean,
}

const StripeSepaForm = (props: OwnProps) => {

    const stripe = useStripe()
    const elements = useElements()
    const [error, setError] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(false)

    const handleSubmit = async (event) => {
        event.preventDefault()
        if (!stripe || !elements) {
            return
        }

        const iban = elements.getElement(IbanElement)

        if (!iban) {
            return
        }

        const accountholderName = event.target["accountholder-name"]
        const email = event.target.email

        if (props.saveAndChargeLater) {
            ContactService.SaveSEPAIntent(props.contactId).then(async res => {
                stripe.confirmSepaDebitSetup(res.id, {
                    payment_method: {
                        sepa_debit: iban,
                        billing_details: {
                            name: accountholderName.value,
                            email: email.value,
                        },
                    }
                }).then(function (result) {
                    if(result.error && result.error.message){
                        setError((result.error.message))
                        setLoading(false)
                    }
                    else{
                        props.onSetupIntentSubmit(result)
                    }
                })
            })
        } else {
            //TODO: process payment without save
            return
        }


    }

    return (
        <StripeIbanForm onSubmit={handleSubmit} disabled={!stripe} error={error} testMode={props.testMode} loading={loading} />
    )
}

export default StripeSepaForm


// WEBPACK FOOTER //
// ./src/common/sepa/stripe/StripeSepaForm.tsx